import React from 'react';
import { usePermissionStore } from '../stores/permissionStore';

interface PermissionGuardProps {
  permission: string | string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
  mode?: 'all' | 'any';
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  permission,
  children,
  fallback = null,
  mode = 'any',
}) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissionStore();

  const hasAccess = () => {
    if (typeof permission === 'string') {
      return hasPermission(permission);
    }
    
    if (Array.isArray(permission)) {
      if (mode === 'all') {
        return hasAllPermissions(permission);
      } else {
        return hasAnyPermission(permission);
      }
    }
    
    return false;
  };

  return hasAccess() ? <>{children}</> : <>{fallback}</>;
};

interface PermissionButtonProps {
  permission: string | string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
  mode?: 'all' | 'any';
  [key: string]: any;
}

export const PermissionButton: React.FC<PermissionButtonProps> = ({
  permission,
  children,
  fallback,
  mode = 'any',
  ...props
}) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissionStore();

  const hasAccess = () => {
    if (typeof permission === 'string') {
      return hasPermission(permission);
    }
    
    if (Array.isArray(permission)) {
      if (mode === 'all') {
        return hasAllPermissions(permission);
      } else {
        return hasAnyPermission(permission);
      }
    }
    
    return false;
  };

  if (!hasAccess()) {
    return fallback ? <>{fallback}</> : null;
  }

  return <button {...props}>{children}</button>;
};